import {
  RESTORE_UPDATE_PROFILE_INITIAL,
  UPDATE_PROFILE_SUCCESS,
  FETCH_PROFILE_SUCCESS,
  ADD_BANK_SUCCESS,
  FETCH_ALL_BANKS_SUCCESS,
  FETCH_WALLET_DETAILS_SUCCESS,
  WITHDRAW_FUNDS_SUCCESS,
  RESTORE_WITHDRAW_FUNDS_INITIAL,
  RESTORE_ADD_BANK_INITIAL,
  CANCEL_SUBSCRIPTION_SUCCESS,
  CANCEL_TRIAL_SUCCESS,
  RESTORE_CANCEL_SUBSCRIPTION_INITIAL,
  RESTORE_CANCEL_TRIAL_INITIAL,
  REACTIVATE_TRIAL_SUCCESS,
  RESTORE_REACTIVATE_TRIAL_INITIAL,
  REACTIVATE_SUBSCRIPTION_SUCCESS,
  RESTORE_REACTIVATE_SUBSCRIPTION_INITIAL,
  WEB_PURCHASE_SUCCESS,
  RESTORE_WEB_PURCHASE_INITIAL,
  FETCH_SUBSCRIPTION_DETAILS_SUCCESS,
  CHANGE_PASSWORD_SUCCESS,
  RESTORE_CHANGE_PASSWORD_INITIAL,
  DELETE_ACCOUNT_SUCCESS,
  RESTORE_DELETE_ACCOUNT_INITIAL,
  UPLOAD_PROFILE_IMAGE_SUCCESS,
  RESTORE_UPLOAD_PROFILE_IMAGE_INITIAL,
  FETCH_LEADERBOARD_SUMMARY_SUCCESS,
  FETCH_LEADERBOARD_CATEGORY,
  FETCH_LEADERBOARD_CATEGORY_SUCCESS,
  FETCH_LEADERBOARD_CATEGORY_FAILURE,
  FETCH_ANALYTICS_OVERVIEW_SUMMARY,
  FETCH_ANALYTICS_OVERVIEW_SUMMARY_SUCCESS,
  FETCH_ANALYTICS_OVERVIEW_SUMMARY_FAILURE,
  FETCH_ANALYTICS_READING_HISTORY,
  FETCH_ANALYTICS_READING_HISTORY_SUCCESS,
  FETCH_ANALYTICS_READING_HISTORY_FAILURE,
  FETCH_ANALYTICS_READING_STREAK,
  FETCH_ANALYTICS_READING_STREAK_SUCCESS,
  FETCH_ANALYTICS_READING_STREAK_FAILURE,
  FETCH_ANALYTICS_ACHIEVEMENTS,
  FETCH_ANALYTICS_ACHIEVEMENTS_SUCCESS,
  FETCH_ANALYTICS_ACHIEVEMENTS_FAILURE,
  FETCH_ANALYTICS_INSIGHTS,
  FETCH_ANALYTICS_INSIGHTS_SUCCESS,
  FETCH_ANALYTICS_INSIGHTS_FAILURE,
  FETCH_READING_PREFERENCES,
  FETCH_READING_PREFERENCES_SUCCESS,
  FETCH_READING_PREFERENCES_FAILURE,
  UPDATE_READING_PREFERENCES,
  UPDATE_READING_PREFERENCES_SUCCESS,
  UPDATE_READING_PREFERENCES_FAILURE,
} from "../ActionTypes";

const INIT_STATE = {
  updateProfileSuccess: false,
  updateProfileFailure: false,
  profileData: {},
  addBankSuccess: false,
  addBankFailure: false,
  allBanks: [],
  walletDetails: {},
  withdrawFundsSuccess: false,
  withdrawFundsFailure: false,

  cancelTrialSuccess: false,
  cancelTrailFailure: false,
  cancelSubscriptionSuccess: false,
  cancelSubscriptionFailure: false,

  reactivateTrialSuccess: false,
  reactivateTrailFailure: false,
  reactivateSubscriptionSuccess: false,
  reactivateSubscriptionFailure: false,

  webPurchaseSuccess: false,
  webPurchaseFailure: false,

  subscriptionDetails: {},
  passwordChangeSuccess: false,
  passwordChangeFailure: false,

  deleteAccountSuccess: false,
  deleteAccountFailure: false,

  uploadProfImagSuccess: false,
  uploadProfImagFailure: false,

  leaderBoardSummary: {},
  leaderBoardCategory: {},
  leaderBoardCategoryLoading: false,
  leaderBoardCategoryFailure: false,

  analyticsOverviewSummary: {},
  analyticsOverviewSummaryLoading: false,
  analyticsOverviewSummaryFailure: false,

  analyticsReadingHistory: {},
  analyticsReadingHistoryLoading: false,
  analyticsReadingHistoryFailure: false,

  analyticsReadingStreak: {},
  analyticsReadingStreakLoading: false,
  analyticsReadingStreakFailure: false,

  analyticsAchievements: {},
  analyticsAchievementsLoading: false,
  analyticsAchievementsFailure: false,

  analyticsInsights: {},
  analyticsInsightsLoading: false,
  analyticsInsightsFailure: false,

  readingPreferences: {},
  readingPreferencesLoading: false,
  readingPreferencesFailure: false,
  updateReadingPreferencesLoading: false,
  updateReadingPreferencesSuccess: false,
  updateReadingPreferencesFailure: false,
};

const profileReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_PROFILE_SUCCESS: {
      if (action.payload === true) {
        return {
          ...state,
          updateProfileSuccess: true,
          updateProfileFailure: false,
        };
      } else {
        return {
          ...state,
          updateProfileSuccess: false,
          updateProfileFailure: true,
        };
      }
    }

    case RESTORE_UPDATE_PROFILE_INITIAL: {
      return {
        ...state,
        updateProfileSuccess: false,
        updateProfileFailure: false,
      };
    }

    case FETCH_PROFILE_SUCCESS: {
      return {
        ...state,
        profileData: action.payload,
      };
    }

    case ADD_BANK_SUCCESS: {
      if (action.payload === "Bank Details Updated") {
        return {
          ...state,
          addBankSuccess: true,
          addBankFailure: false,
        };
      } else {
        return {
          ...state,
          addBankSuccess: false,
          addBankFailure: true,
        };
      }
    }

    case RESTORE_ADD_BANK_INITIAL: {
      return {
        ...state,
        addBankSuccess: false,
        addBankFailure: false,
      };
    }

    case FETCH_ALL_BANKS_SUCCESS: {
      return {
        ...state,
        allBanks: action.payload,
      };
    }

    case FETCH_WALLET_DETAILS_SUCCESS: {
      return {
        ...state,
        walletDetails: action.payload,
      };
    }

    case WITHDRAW_FUNDS_SUCCESS: {
      if (action.payload === "Balance too Low") {
        return {
          ...state,
          withdrawFundsSuccess: false,
          withdrawFundsFailure: true,
        };
      } else {
        return {
          ...state,
          withdrawFundsSuccess: true,
          withdrawFundsFailure: false,
        };
      }
    }

    case RESTORE_WITHDRAW_FUNDS_INITIAL: {
      return {
        ...state,
        withdrawFundsSuccess: false,
        withdrawFundsFailure: false,
      };
    }

    case CANCEL_TRIAL_SUCCESS: {
      if (action.payload === true) {
        return {
          ...state,
          cancelTrialSuccess: true,
          cancelTrailFailure: false,
        };
      } else {
        return {
          ...state,
          cancelTrialSuccess: false,
          cancelTrailFailure: true,
        };
      }
    }

    case RESTORE_CANCEL_TRIAL_INITIAL: {
      return {
        ...state,
        cancelTrialSuccess: false,
        cancelTrailFailure: false,
      };
    }

    case CANCEL_SUBSCRIPTION_SUCCESS: {
      if (action.payload === true) {
        return {
          ...state,
          cancelSubscriptionSuccess: true,
          cancelSubscriptionFailure: false,
        };
      } else {
        return {
          ...state,
          cancelSubscriptionSuccess: false,
          cancelSubscriptionFailure: true,
        };
      }
    }

    case RESTORE_CANCEL_SUBSCRIPTION_INITIAL: {
      return {
        ...state,
        cancelSubscriptionFailure: false,
        cancelSubscriptionSuccess: false,
      };
    }

    case REACTIVATE_TRIAL_SUCCESS: {
      if (action.payload === true) {
        return {
          ...state,
          reactivateTrialSuccess: true,
          reactivateTrailFailure: false,
        };
      } else {
        return {
          ...state,
          reactivateTrialSuccess: false,
          reactivateTrailFailure: true,
        };
      }
    }

    case RESTORE_REACTIVATE_TRIAL_INITIAL: {
      return {
        ...state,
        reactivateTrialSuccess: false,
        reactivateTrailFailure: false,
      };
    }

    case REACTIVATE_SUBSCRIPTION_SUCCESS: {
      if (action.payload === true) {
        return {
          ...state,
          reactivateSubscriptionSuccess: true,
          reactivateSubscriptionFailure: false,
        };
      } else {
        return {
          ...state,
          reactivateSubscriptionSuccess: false,
          reactivateSubscriptionFailure: true,
        };
      }
    }

    case RESTORE_REACTIVATE_SUBSCRIPTION_INITIAL: {
      return {
        ...state,
        reactivateSubscriptionFailure: false,
        reactivateSubscriptionSuccess: false,
      };
    }

    case FETCH_SUBSCRIPTION_DETAILS_SUCCESS: {
      return {
        ...state,
        subscriptionDetails: action.payload,
      };
    }

    case WEB_PURCHASE_SUCCESS: {
      if (action.payload === true) {
        return {
          ...state,
          webPurchaseSuccess: true,
          webPurchaseFailure: false,
        };
      } else {
        return {
          ...state,
          webPurchaseSuccess: false,
          webPurchaseFailure: true,
        };
      }
    }

    case RESTORE_WEB_PURCHASE_INITIAL: {
      return {
        ...state,
        webPurchaseFailure: false,
        webPurchaseSuccess: false,
      };
    }

    case CHANGE_PASSWORD_SUCCESS: {
      if (action.payload === true) {
        return {
          ...state,
          passwordChangeSuccess: true,
          passwordChangeFailure: false,
        };
      } else {
        return {
          ...state,
          passwordChangeSuccess: false,
          passwordChangeFailure: true,
        };
      }
    }

    case RESTORE_CHANGE_PASSWORD_INITIAL: {
      return {
        ...state,
        passwordChangeFailure: false,
        passwordChangeSuccess: false,
      };
    }

    case DELETE_ACCOUNT_SUCCESS: {
      if (action.payload === true) {
        return {
          ...state,
          deleteAccountSuccess: true,
          deleteAccountFailure: false,
        };
      } else {
        return {
          ...state,
          deleteAccountSuccess: false,
          deleteAccountFailure: true,
        };
      }
    }

    case RESTORE_DELETE_ACCOUNT_INITIAL: {
      return {
        ...state,
        deleteAccountSuccess: false,
        deleteAccountFailure: false,
      };
    }

    case UPLOAD_PROFILE_IMAGE_SUCCESS: {
      if (action.payload === true) {
        return {
          ...state,
          uploadProfImagSuccess: true,
          uploadProfImagFailure: false,
        };
      } else {
        return {
          ...state,
          uploadProfImagSuccess: false,
          uploadProfImagFailure: true,
        };
      }
    }

    case RESTORE_UPLOAD_PROFILE_IMAGE_INITIAL: {
      return {
        ...state,
        uploadProfImagSuccess: false,
        uploadProfImagFailure: false,
      };
    }

    case FETCH_LEADERBOARD_SUMMARY_SUCCESS: {
      return {
        ...state,
        leaderBoardSummary: action.payload,
      };
    }

    case FETCH_LEADERBOARD_CATEGORY: {
      return {
        ...state,
        leaderBoardCategory: {},
        leaderBoardCategoryLoading: true,
        leaderBoardCategoryFailure: false,
      };
    }

    case FETCH_LEADERBOARD_CATEGORY_SUCCESS: {
      return {
        ...state,
        leaderBoardCategory: action.payload,
        leaderBoardCategoryLoading: false,
        leaderBoardCategoryFailure: false,
      };
    }

    case FETCH_LEADERBOARD_CATEGORY_FAILURE: {
      return {
        ...state,
        leaderBoardCategory: {},
        leaderBoardCategoryLoading: false,
        leaderBoardCategoryFailure: true,
      };
    }

    case FETCH_ANALYTICS_OVERVIEW_SUMMARY: {
      return {
        ...state,
        analyticsOverviewSummary: {},
        analyticsOverviewSummaryLoading: true,
        analyticsOverviewSummaryFailure: false,
      };
    }

    case FETCH_ANALYTICS_OVERVIEW_SUMMARY_SUCCESS: {
      return {
        ...state,
        analyticsOverviewSummary: action.payload,
        analyticsOverviewSummaryLoading: false,
        analyticsOverviewSummaryFailure: false,
      };
    }

    case FETCH_ANALYTICS_OVERVIEW_SUMMARY_FAILURE: {
      return {
        ...state,
        analyticsOverviewSummary: {},
        analyticsOverviewSummaryLoading: false,
        analyticsOverviewSummaryFailure: true,
      };
    }

    case FETCH_ANALYTICS_READING_HISTORY: {
      return {
        ...state,
        analyticsReadingHistory: {},
        analyticsReadingHistoryLoading: true,
        analyticsReadingHistoryFailure: false,
      };
    }

    case FETCH_ANALYTICS_READING_HISTORY_SUCCESS: {
      return {
        ...state,
        analyticsReadingHistory: action.payload,
        analyticsReadingHistoryLoading: false,
        analyticsReadingHistoryFailure: false,
      };
    }

    case FETCH_ANALYTICS_READING_HISTORY_FAILURE: {
      return {
        ...state,
        analyticsReadingHistory: {},
        analyticsReadingHistoryLoading: false,
        analyticsReadingHistoryFailure: true,
      };
    }

    case FETCH_ANALYTICS_READING_STREAK: {
      return {
        ...state,
        analyticsReadingStreak: {},
        analyticsReadingStreakLoading: true,
        analyticsReadingStreakFailure: false,
      };
    }

    case FETCH_ANALYTICS_READING_STREAK_SUCCESS: {
      return {
        ...state,
        analyticsReadingStreak: action.payload,
        analyticsReadingStreakLoading: false,
        analyticsReadingStreakFailure: false,
      };
    }

    case FETCH_ANALYTICS_READING_STREAK_FAILURE: {
      return {
        ...state,
        analyticsReadingStreak: {},
        analyticsReadingStreakLoading: false,
        analyticsReadingStreakFailure: true,
      };
    }

    case FETCH_ANALYTICS_ACHIEVEMENTS: {
      return {
        ...state,
        analyticsAchievements: {},
        analyticsAchievementsLoading: true,
        analyticsAchievementsFailure: false,
      };
    }

    case FETCH_ANALYTICS_ACHIEVEMENTS_SUCCESS: {
      return {
        ...state,
        analyticsAchievements: action.payload,
        analyticsAchievementsLoading: false,
        analyticsAchievementsFailure: false,
      };
    }

    case FETCH_ANALYTICS_ACHIEVEMENTS_FAILURE: {
      return {
        ...state,
        analyticsAchievements: {},
        analyticsAchievementsLoading: false,
        analyticsAchievementsFailure: true,
      };
    }

    case FETCH_ANALYTICS_INSIGHTS: {
      return {
        ...state,
        analyticsInsights: {},
        analyticsInsightsLoading: true,
        analyticsInsightsFailure: false,
      };
    }

    case FETCH_ANALYTICS_INSIGHTS_SUCCESS: {
      return {
        ...state,
        analyticsInsights: action.payload,
        analyticsInsightsLoading: false,
        analyticsInsightsFailure: false,
      };
    }

    case FETCH_ANALYTICS_INSIGHTS_FAILURE: {
      return {
        ...state,
        analyticsInsights: {},
        analyticsInsightsLoading: false,
        analyticsInsightsFailure: true,
      };
    }

    case FETCH_READING_PREFERENCES: {
      return {
        ...state,
        readingPreferencesLoading: true,
        readingPreferencesFailure: false,
      };
    }

    case FETCH_READING_PREFERENCES_SUCCESS: {
      return {
        ...state,
        readingPreferences: action.payload,
        readingPreferencesLoading: false,
        readingPreferencesFailure: false,
      };
    }

    case FETCH_READING_PREFERENCES_FAILURE: {
      return {
        ...state,
        readingPreferencesLoading: false,
        readingPreferencesFailure: true,
      };
    }

    case UPDATE_READING_PREFERENCES: {
      return {
        ...state,
        updateReadingPreferencesLoading: true,
        updateReadingPreferencesSuccess: false,
        updateReadingPreferencesFailure: false,
      };
    }

    case UPDATE_READING_PREFERENCES_SUCCESS: {
      return {
        ...state,
        readingPreferences: action.payload,
        updateReadingPreferencesLoading: false,
        updateReadingPreferencesSuccess: true,
        updateReadingPreferencesFailure: false,
      };
    }

    case UPDATE_READING_PREFERENCES_FAILURE: {
      return {
        ...state,
        updateReadingPreferencesLoading: false,
        updateReadingPreferencesSuccess: false,
        updateReadingPreferencesFailure: true,
      };
    }

    default:
      return state;
  }
};

export default profileReducer;
